import { render, staticRenderFns } from "./SeamlessScroll.vue?vue&type=template&id=4b092e4f&scoped=true&"
import script from "./SeamlessScroll.vue?vue&type=script&lang=js&"
export * from "./SeamlessScroll.vue?vue&type=script&lang=js&"
import style0 from "./SeamlessScroll.vue?vue&type=style&index=0&id=4b092e4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b092e4f",
  null
  
)

export default component.exports